module.exports = __webpack_public_path__ + "img/fa-regular-400.0bb42845.svg";